<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    // Nicht reaktiv: Timer, Anfrage-Zähler und Geocoder je Instanz
    this.timeout = null;
    this.queryId = 0;
    this.destroyed = false;
    this.geocoder = null;

    GeocoderFactory().then(geocoder => {
      if (!this.destroyed) {
        this.geocoder = geocoder;
      }
    });
  },

  beforeDestroy() {
    this.destroyed = true;
    this.reset(false);
  },

  watch: {
    search(val) {
      if (!val) {
        this.reset(!this.select);
        return;
      }

      if (val !== this.select && !(this.select && val === this.select.text)) {
        this.querySelections(val);
      }
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    // Beendet Timer und laufende Anfrage und invalidiert verspätete Antworten.
    reset(clearItems) {
      this.queryId++;

      if (this.timeout != null) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;

      if (clearItems) {
        this.items = [];
      }
    },

    querySelections(value) {
      this.reset(false);

      if (!this.geocoder) {
        return;
      }

      const queryId = this.queryId;
      this.loading = true;

      this.timeout = setTimeout(() => {
        this.timeout = null;

        this.geocoder.autocomplete(value).then(items => {
          if (queryId !== this.queryId || this.destroyed) {
            return;
          }

          this.loading = false;

          if (items !== null) {
            this.items = items.slice();
          }
        });
      }, 150);
    },

    change(o) {
      this.reset(false);
      this.$emit("change", o);
    }
  }
};
</script>
